/**
 * An element that takes focus whenever `focusKey` changes, and once when it
 * first appears.
 *
 * A page's heading passes its title, so reaching a page — by a link as much
 * as by a full load — moves focus to the name of where the reader is, and two
 * pages sharing one component are still two pages. A field that should take
 * focus only on arriving passes a key that never changes, such as null.
 */import{useEffect,useRef}from"react";export default function useFocusOn(focusKey){const ref=useRef(null);useEffect(()=>{if(ref.current!=null){ref.current.focus();}},[focusKey]);return ref;}